import { render, staticRenderFns } from "./querykeyperson.vue?vue&type=template&id=3a1086ee"
import script from "./querykeyperson.vue?vue&type=script&lang=js"
export * from "./querykeyperson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports